@if (cart) {
<div class="summary-details">
  <div class="summary-row">
    @if ((isOrderSummaryRelatedCustomTranslationsEnabled$ | async) !== null) {
    <div class="summary-label">
      {{
        'cart.orderSummary.subtotal'
          | cxTranslate
            : {
                context: setCustomContext(
                  isOrderSummaryRelatedCustomTranslationsEnabled$ | async,
                  activeCountry$ | async,
                  activeLanguage$ | async
                )
              }
      }}
    </div>
    } @if (isCheckoutPage || !showSrp) {
    <div class="summary-amount">
      {{ cart.subTotal?.formattedValue }}
    </div>
    }
  </div>
  <div class="summary-row">
    @if ((isDiscountRelatedCustomTranslationsEnabled$ | async) !== null) {
    <div class="summary-label">
      {{
        'cart.orderSummary.discount'
          | cxTranslate
            : {
                context: setCustomContext(
                  isDiscountRelatedCustomTranslationsEnabled$ | async,
                  activeCountry$ | async,
                  activeLanguage$ | async
                )
              }
      }}
    </div>
    } @if (isCheckoutPage || !showSrp) {
    <div class="summary-amount">
      {{ cart.orderDiscounts?.formattedValue }}
    </div>
    }
  </div>
  @if (showDeliveryFee$ | async) {
  <div class="summary-row" [ngClass]="(showActiveSnahCountry$ | async) ? 'hasGap' : ''">
    <div class="summary-label js-delivery-fee">
      {{ 'cart.orderSummary.estimatedShipping' | cxTranslate }}
    </div>
    @if (isCheckoutPage || !showSrp) {
    <div class="summary-amount js-delivery-cost" [attr.data-value]="cart.deliveryCost?.value">
      @if (!(showActiveSnahCountry$ | async)) { @if (!(showDeliveryFeeCustomMsg$ | async) && (showDeliveryFeeCustomMsg$
      | async) !== null) {
      <span>{{
        cart?.deliveryCost?.value > 0
          ? cart?.deliveryCost?.formattedValue
          : ('myAccount.orderDetails.orderTotalSummary.deliveryFeeFree' | cxTranslate)
      }}</span>
      } } @else { @if (!(showDeliveryFeeCustomMsg$ | async) && (showDeliveryFeeCustomMsg$ | async) !== null) {
      <span>{{
        hasFreeFreight(cart?.freeFreight, cart?.freeDeliveryModes)
          ? ('myAccount.orderDetails.orderTotalSummary.deliveryFeeFree' | cxTranslate)
          : ('myAccount.orderDetails.orderTotalSummary.calculateFee' | cxTranslate)
      }}</span>
      } } @if (showDeliveryFeeCustomMsg$ | async) {
      <span
        [innerHTML]="
          'cart.orderSummary.deliveryFeeCustomMsg' | cxTranslate : { context: (isMobile$ | async) ? 'mobile' : '' }
        "
      ></span>
      }
    </div>
    }
  </div>
  } @if (showSalesTax$ | async) {
  <div class="summary-row">
    @if ((isOrderSummaryRelatedCustomTranslationsEnabled$ | async) !== null) {
    <div class="summary-label">
      {{
        'cart.orderSummary.salesTax'
          | cxTranslate
            : {
                context: setCustomContext(
                  isOrderSummaryRelatedCustomTranslationsEnabled$ | async,
                  activeCountry$ | async,
                  activeLanguage$ | async
                )
              }
      }}
    </div>
    } @if (isCheckoutPage || !showSrp) {
    <div class="summary-amount">
      {{ isCheckoutPage ? getCart?.totalTax?.formattedValue : cart?.totalTax?.formattedValue }}
    </div>
    }
  </div>
  }
  <!-- Total Summary -->
  <div class="summary-row summary-total">
    @if ((isOrderSummaryRelatedCustomTranslationsEnabled$ | async) !== null) {
    <div class="summary-label">
      {{
        'cart.orderSummary.total'
          | cxTranslate
            : {
                context: setCustomContext(
                  isOrderSummaryRelatedCustomTranslationsEnabled$ | async,
                  activeCountry$ | async,
                  activeLanguage$ | async
                )
              }
      }}
    </div>
    } @if (isCheckoutPage || !showSrp) {
    <div class="summary-amount">
      @if (hideSalesTaxInCart$ | async) {
      {{ cart.totalPrice?.formattedValue }}
      } @else {
      {{ isCheckoutPage ? getCart?.totalPriceWithTax?.formattedValue : cart?.totalPriceWithTax?.formattedValue }}
      }
    </div>
    }
  </div>
  @if (showGstMsg$ | async) {
  <div class="summary-row gst">
    {{ 'checkout.group.gst.' + (taxLabel$ | async) | cxTranslate }}
  </div>
  } @if ((showActiveSnahCountry$ | async) && freightPrice && freightPrice !== '$0') {
  <div class="summary-row freight">
    <mat-icon svgIcon="freight-icon"></mat-icon>
    <span>{{ 'checkout.group.customFreight.freight' | cxTranslate : { freightLevel: freightPrice } }}</span>
  </div>
  }
</div>
}
